import React, { useState, useEffect } from "react";
import Slider from "rc-slider";

const PriceRange = ({ filterPrice, handlePriceRange, handleMinPriceChange, handleMaxPriceChange, minPrice, maxPrice }) => {
  const [value, setValue] = useState([filterPrice.min, filterPrice.max]);

  useEffect(() => {
    setValue([minPrice, maxPrice]);
  }, [minPrice, maxPrice]);

  const handleSliderChange = (newValue) => {
    setValue(newValue);
    handlePriceRange(newValue);
  };

  const handleMinChange = (event) => {
    const newValue = [event.target.value, value[1]];
    setValue(newValue);
    handleMinPriceChange(event);
  };

  const handleMaxChange = (event) => {
    const newValue = [value[0], event.target.value];
    setValue(newValue);
    handleMaxPriceChange(event);
  };

  return (
    <div className="price-range-slide">
      <div className="d-flex justify-content-between align-items-center filter-content">
        <h3 className="filter-title mb-0">Price Range</h3>
      </div>
      <div className="range-slide">
        <Slider
          range
          step={100}
          onChange={handleSliderChange}
          tipFormatter={(val) => `${val}`}
          tipProps={{ visible: true }}
          value={value}
          min={filterPrice?.min}
          max={filterPrice?.max}
          trackStyle={[{ backgroundColor: "#1B73E7", height: "2px" }]}
          railStyle={{ backgroundColor: "#ddd", height: "2px" }}
        />
      </div>
      <div className="price-range-bounds">
        <div className="price-range-bound">
          <label htmlFor="price-range-min" className="price-range-bound-label">
            Minimum
          </label>
          <div className="price-range-bound-value-row">
            <span className="price-range-bound-currency">$</span>
            <input
              id="price-range-min"
              type="text"
              inputMode="numeric"
              className="price-range-bound-value"
              name="min"
              value={value[0]}
              onChange={handleMinChange}
            />
          </div>
        </div>
        <div className="price-range-bound">
          <label htmlFor="price-range-max" className="price-range-bound-label">
            Maximum
          </label>
          <div className="price-range-bound-value-row">
            <span className="price-range-bound-currency">$</span>
            <input
              id="price-range-max"
              type="text"
              inputMode="numeric"
              className="price-range-bound-value"
              name="max"
              value={value[1]}
              onChange={handleMaxChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PriceRange;
